export default {
  strict: true,
  namespaced: true,
  state: {
    list: []
  },
  mutations: {
    cleanList (state) { state.list = [] },
    setList (state, value) { state.list = value },
    sortList (state, data) {
      if (state.list.length < 0) {
        return
      }

      let lat = data.lat
      let lng = data.lng
      let airportList = state.list

      state.list = airportList.sort((lhs, rhs) => {
        let getDistance = (lat1, lng1, lat2, lng2) => {
          let radlat1 = Math.PI * lat1 / 180
          let radlat2 = Math.PI * lat2 / 180
          let theta = lng1 - lng2
          let radtheta = Math.PI * theta / 180
          let dist = Math.sin(radlat1) * Math.sin(radlat2) + Math.cos(radlat1) *
            Math.cos(radlat2) * Math.cos(radtheta)
          dist = Math.acos(dist)
          dist = dist * 180 / Math.PI
          dist = dist * 60 * 1.1515
          return dist
        }

        let lhsDistance = getDistance(lat, lng, lhs.lat, lhs.lng)
        let rhsDistance = getDistance(lat, lng, rhs.lat, rhs.lng)

        if (lhsDistance < rhsDistance) { return -1 }
        if (rhsDistance < lhsDistance) { return 1 }
        return 0
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/airports.js